import React, { Fragment } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import { InputLabel, MenuItem, Select } from '@material-ui/core'
import * as firebase from 'firebase/app'
import 'firebase/firestore'

function refreshPage() {
  window.location.reload(false)
}
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const setData = (
  db,
  question,
  answer1,
  answer2,
  answer3,
  answer4,
  right_answer,
  level
) => {
  db.collection('questions')
    .add({
      answers: [answer1, answer2, answer3, answer4],
      right_answer: right_answer,
      date: firebase.firestore.Timestamp.now(),
      question: question,
      level: level,
    })
    .then(function (docRef) {
      console.log('Document written with ID: ', docRef.id)
    })
    .catch(function (error) {
      console.error('Error adding document: ', error)
    })
}

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

export default function QuestionForm() {
  const classes = useStyles()
  const db = firebase.firestore()
  const [answer, setAnswer] = React.useState(0)
  const [answer1, setAnswer1] = React.useState('')
  const [answer2, setAnswer2] = React.useState('')
  const [answer3, setAnswer3] = React.useState('')
  const [answer4, setAnswer4] = React.useState('')
  const [question, setQuestion] = React.useState('')
  const [level, setLevel] = React.useState(1)

  return (
    <Fragment>
      <Container component='main' maxWidth='md'>
        <div className={classes.paper}>
          <Typography component='h1' variant='h4'>
            Soru Ekle
          </Typography>
          <form className={classes.form}>
            <TextField
              variant='outlined'
              margin='normal'
              required
              fullWidth
              id='question'
              label='Soru'
              name='question'
              autoFocus
              onInput={(e) => setQuestion(e.target.value)}
            />
            <Grid container>
              <Grid item xs={6}>
                <TextField
                  variant='outlined'
                  margin='normal'
                  required
                  fullWidth
                  name='answer1'
                  label='Cevap 1'
                  id='answer1'
                  onInput={(e) => setAnswer1(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  variant='outlined'
                  margin='normal'
                  required
                  fullWidth
                  name='answer2'
                  label='Cevap 2'
                  id='answer2'
                  onInput={(e) => setAnswer2(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  variant='outlined'
                  margin='normal'
                  required
                  fullWidth
                  name='answer3'
                  label='Cevap 3'
                  id='answer3'
                  onInput={(e) => setAnswer3(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  variant='outlined'
                  margin='normal'
                  required
                  fullWidth
                  name='answer4'
                  label='Cevap 4'
                  id='answer4'
                  onInput={(e) => setAnswer4(e.target.value)}
                />
              </Grid>

              <Grid item xs={6}>
                <InputLabel id='demo-simple-select-label'>
                  Zorluk Seviyesi
                </InputLabel>
                <Select
                  labelId='demo-simple-select-label'
                  id='demo-simple-select'
                  value={level}
                  onChange={(e) => setLevel(e.target.value)}
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={6}>
                <InputLabel id='demo-simple-select-label'>
                  Doğru Cevap
                </InputLabel>
                <Select
                  labelId='demo-simple-select-label'
                  id='demo-simple-select'
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                >
                  <MenuItem value={0}>Cevap 1</MenuItem>
                  <MenuItem value={1}>Cevap 2</MenuItem>
                  <MenuItem value={2}>Cevap 3</MenuItem>
                  <MenuItem value={3}>Cevap 4</MenuItem>
                </Select>
              </Grid>
            </Grid>
            <Button
              type='submit'
              fullWidth
              variant='contained'
              color='primary'
              className={classes.submit}
              onClick={async (e) => {
                e.preventDefault()
                setData(
                  db,
                  question,
                  answer1,
                  answer2,
                  answer3,
                  answer4,
                  answer,
                  level
                )
                await sleep(1000)
                refreshPage()
              }}
            >
              Gönder
            </Button>
          </form>
        </div>
      </Container>
    </Fragment>
  )
}
